/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import {
  DeliveryTruckIcon,
  RailroadIcon,
  // BargeIcon,
  // PipelineIcon,
  // VesselIcon,
} from "../icons";
import PickerOption from "./PickerOption";

const ModePicker = ({
  value,
  setValue,
}: {
  value: string;
  setValue: (value: string) => void;
}) => {
  const select = (mode: string) => {
    if (value === mode && value === "") {
      return;
    }

    setValue(mode);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 15,
      }}
    >
      <div
        style={{
          display: "flex",
          gap: 15,
        }}
      >
        <PickerOption
          width={90}
          height={80}
          label="All"
          select={() => select("")}
          selected={value === ""}
        />
        <PickerOption
          width={90}
          height={80}
          label="Truck"
          Icon={DeliveryTruckIcon}
          select={() => select("TRUCK")}
          selected={value === "TRUCK"}
        />
        <PickerOption
          width={90}
          height={80}
          label="Rail"
          Icon={RailroadIcon}
          select={() => select("RAIL")}
          selected={value === "RAIL"}
        />
      </div>
      {/* <div
        style={{
          display: "flex",
          gap: 15,
        }}
      >
        <PickerOption
          width={90}
          height={80}
          label="Barge"
          Icon={BargeIcon}
          select={() => select("BARGE")}
          selected={value === "BARGE"}
        />
        <PickerOption
          width={90}
          height={80}
          label="Vessel"
          Icon={VesselIcon}
          select={() => select("VESSEL")}
          selected={value === "VESSEL"}
        />
        <PickerOption
          width={90}
          height={80}
          label="Pipeline"
          Icon={PipelineIcon}
          select={() => select("PIPELINE")}
          selected={value === "PIPELINE"}
        />
      </div> */}
    </div>
  );
};

export default ModePicker;
